import { editorOrAbovePolicy } from "./common";

/** Search Analytics リソースのポリシー定義です。 */
export const SA_POLICIES = {
  /** プロジェクトの作成・並び替えなど編集操作の可否を判定します。 */
  "sa-project:edit": editorOrAbovePolicy,
  /** ビュー（Search Console グループ等）の追加・並び替え可否を判定します。 */
  "sa-view:edit": editorOrAbovePolicy,
  /** Search Analytics の BigQuery 設定操作の可否を判定します。 */
  "sa-bigquery:edit": editorOrAbovePolicy,
} as const;
